import {inject, Injectable} from '@angular/core';
import {DailyFeedbackReportsApiService} from "./daily-feedback-reports-api.service";
import {RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {
  DailyFeedbackReportsAggregationData,
  DailyFeedbackReportsData, DateRange
} from "../types/daily-feedback-reports-page.types";
import {DailyFeedbackReportsPaginationDataService} from "./daily-feedback-reports-pagination-data.service";
import {DailyFeedbackReportsDataService} from "./daily-feedback-reports-data.service";
import {DailyFeedbackReportsAggregationDataService} from "./daily-feedback-reports-aggregation-data.service";

@Injectable({
  providedIn: 'root'
})
export class DailyFeedbackReportsService {
  private dailyFeedbackReportsApiService: DailyFeedbackReportsApiService = inject(DailyFeedbackReportsApiService);
  private dailyFeedbackReportsPaginationDataService: DailyFeedbackReportsPaginationDataService = inject(DailyFeedbackReportsPaginationDataService);
  private dailyFeedbackReportsDataService: DailyFeedbackReportsDataService = inject(DailyFeedbackReportsDataService);
  private dailyFeedbackReportsAggregationDataService: DailyFeedbackReportsAggregationDataService = inject(DailyFeedbackReportsAggregationDataService);

  public async getDailyFeedbackData(dateRange: DateRange): Promise<void> {
    const queryParams = {
      ...this.dailyFeedbackReportsPaginationDataService.paginationProps(),
      ...dateRange
    };

    const data = await this.getDailyFeedbackReportsData(queryParams).catch(() => null);
    const aggregation = await this.getColumnAggregation(queryParams).catch(() =>  null);
    this.dailyFeedbackReportsDataService.setDailyFeedbackReportsData(data);
    this.dailyFeedbackReportsPaginationDataService.setDailyFeedbackReportsPagination(data);
    this.dailyFeedbackReportsAggregationDataService.setDailyFeedbackReportsPagination(aggregation);
  }

  private getDailyFeedbackReportsData(queryParams: RecordsDataRequestQueryParams): Promise<DailyFeedbackReportsData> {
    return new Promise((resolve, reject) => {
      this.dailyFeedbackReportsApiService.getDailyFeedbackReportsData(queryParams).subscribe({
        next: (dailyFeedbackReportsData) => resolve(dailyFeedbackReportsData),
        error: (error) => reject(error)
      });
    });
  }

  private getColumnAggregation(queryParams: RecordsDataRequestQueryParams): Promise<DailyFeedbackReportsAggregationData> {
    return new Promise((resolve, reject) => {
      this.dailyFeedbackReportsApiService.getColumnAggregation(queryParams).subscribe({
        next: (dailyFeedbackReportsAggregationData: DailyFeedbackReportsAggregationData) => resolve(dailyFeedbackReportsAggregationData),
        error: (error) => reject(error)
      });
    });
  }
}
